import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {Passenger, ReportEvent, Ship} from '../model';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  private api_prefix: string;

  constructor(private http: HttpClient) {
    this.api_prefix = environment.backEndUrl;
  }

  getReservationsByEvent(ship_id: string,uuid_event: string, date_from?: string, date_to?: string): Observable<Array<ReportEvent>> {
    let url = this.api_prefix + '/reservations';

    let params: HttpParams = new HttpParams();
    params = params.set('uuid_event', uuid_event);
    params = params.set('ship_id', ship_id);
    if (date_from && date_to) {
      params = params.set('date_from', date_from);
      params = params.set('date_to', date_to);
    }

    return this.http.get<Array<ReportEvent>>(url, { params: params });
  }

  getReservationsByEventWithUUID(uuid_event: string): Observable<any> {
    let url = this.api_prefix + `/reports/events/${uuid_event}`;

    let params: HttpParams = new HttpParams();
    params = params.set('with_uuid', true);

    return this.http.get(url, { params: params });
  }

  getPassenger(numeroCabina: string, ship: Ship): Observable<Array<Passenger>> {
    let url = this.api_prefix + `/profiles`;

    let params: HttpParams = new HttpParams();
    params = params.set('id_cabin', numeroCabina);
    params = params.set("ship_id", ship.id_ship)

    return this.http.get<Array<Passenger>>(url, { params: params });
  }

  massiveReservation(ship_id: string) {
    let url = this.api_prefix + "/reservations/massive";
    let body = {
      ship_id: ship_id,
      flag_value: true
    }
    return this.http.post(url, body);
  }

}
